const testimonial = {
  displayField: 'title',
  name: 'testimonial',
  description: '',
  fields: [
    {
      id: 'title',
      name: 'title',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'text',
      name: 'text',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'author',
      name: 'author',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'testimonial',
    version: 4,
    updatedAt: '2023-08-02T21:20:37.567Z'
  }
};
export default testimonial;